import React from "react";
import Resolvers from "../../../../../componets/Api/internal/serviceapi/samsung";
import Ticket from "./RenderTicket";
import LoaderTicket from "./LoadingTicket";

export default class ErrorTicket extends React.Component {
  state = {
    tickets: [],
    loading: false
  };

  getErrorTickets = async () => {
    this.setState({ loading: true });
    var x = await Resolvers({ ...this.props, ErrorTicket: true });
    this.setState({ tickets: x.data, loading: false });
  };

  componentDidMount() {
    this.getErrorTickets();
  }

  refresh = () => {
    this.getErrorTickets();
    this.props.refreshCount();
  }


  render() {
    return (
      <>
      {this.state.loading && (
        <LoaderTicket {...this.props} />
      )}
      {!this.state.loading && (
        <Ticket {...this.props} {...this.state} refresh={this.refresh} />
      )}
       
      </>
    );
  }
}
